<template>
  <div class="view">
    <div class="content">
      <div class="condition">
        <div class="check_wrap">
          <el-radio-group v-model="formdata.type" @change="changetype" size="small">
            <el-radio-button
              v-for="(item,index) in aftersaletype"
              :label="item.value"
              :key="index"
            >{{item.label}}</el-radio-button>
          </el-radio-group>
        </div>
        <div class="search_wrap">
          <el-form :inline="true" :model="formdata" class="form-inline">
            <el-form-item>
              <el-select v-model="formdata.refund_type" placeholder="请选择退款类型" size="small">
                <el-option
                  v-for="item in refundtype"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input v-model="formdata.goods_name" placeholder="请输入售后单" size="small"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="search" size="small"></el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="table_wrap">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column label=" 商品图片 / 商品名称 / 单价 / 数量" width="350">
            <template slot-scope="scope">
              <div class="weui-cells">
                <div v-for="(item,index) in scope.row.goods_info" :key="index" class="weui-cell">
                  <div class="weui-cell__hd"><img :src="item.goods_thumb" /></div>
                  <div class="weui-cell__bd">{{item.goods_name}}</div>
                  <div class="weui-cell__ft">{{item.price}}/{{item.goods_number}}</div>
                </div>
              </div>
            </template>             
          </el-table-column>
          <!-- <el-table-column label="商品图片" width="350">
            <template slot-scope="scope" >
              <div class="td_img">
                <img :src="scope.row.goods_thumb" alt />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="goods_name" label="商品名称"></el-table-column>
          <el-table-column prop="refund_number" label="单价/申请数量">
            <template slot-scope="scope">{{scope.row.refund_price}}/{{scope.row.refund_number}}</template>
          </el-table-column> -->
          <el-table-column prop="refund_money" label="退款总价"></el-table-column>
          <el-table-column prop="refund_reason" label="退款原因"></el-table-column>
          <el-table-column prop="refund_remark" label="退款说明"></el-table-column>
          <el-table-column label="上传凭证">
            <template slot-scope="scope">
              <div
                class="td_img"
                v-if="scope.row.refund_evidence&&scope.row.refund_evidence.length>0"
              >
                <img :src="scope.row.refund_evidence[0]" alt />
              </div>
            </template>
          </el-table-column>
         
          <el-table-column prop="card_id" label="名片主"></el-table-column>
          <el-table-column prop="consignee" label="收货人"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="orderdetail(scope.row,'S')">查看订单</el-button>
              <el-button
                v-if="scope.row.order_status==='退款中'"
                type="text"
                size="small"
                @click="orderdetail(scope.row,'A')"
              >审核</el-button>
              <el-button
                v-if="scope.row.order_status==='已拒绝'"
                type="text"
                size="small"
                @click="delivery(scope.row.id)"
              >发货</el-button>              
            </template>
          </el-table-column>
        </el-table>
        <div class="pag_wrap">
          <el-pagination
            background
            @current-change="pageIndexChange"
            :page-size="page.pagesize"
            :current-page="page.pageindex"
            layout="total, prev, pager, next"
            :total="page.total"
          ></el-pagination>
        </div>
      </div>
    </div>
    <aftersalesDetailDialog
      :id="currentid"
      :type="currenttype"
      :visible.sync="aftersalesdetaildialog"
      v-if="aftersalesdetaildialog"
      @aftersalessuccess="querylist"
    ></aftersalesDetailDialog>
    <deliveryDialog
      :id="currentid"
      :visible.sync="deliverydialog"
      v-if="deliverydialog"
      @deliverysuccess="deliverysuccess"
    ></deliveryDialog>    
  </div>
</template>
<script>
import api from "@/api.js";
import aftersalesDetailDialog from "@/components/dialog/aftersalesDetailDialog.vue";
import { pagination, aftersaletype, refundtype } from "@/util/util.js";
import deliveryDialog from "@/components/dialog/deliveryDialog.vue";
export default {
  name: "aftersalesManagementList",
  components: {
    aftersalesDetailDialog, deliveryDialog
  },
  data() {
    return {
      refundtype: refundtype,
      aftersaletype: aftersaletype,
      formdata: {
        type: 0,
        refund_type: "",
        goods_name: ""
      },
      options: [],
      tableData: [],
      page: {
        pageindex: pagination.pageIndex,
        pagesize: pagination.pageSize,
        total: pagination.total
      },
      aftersalesdetaildialog: false,
      currenttype: "",
      currentid: "",
      deliverydialog: false
    };
  },
  created() {
    this.search();
  },
  methods: {
    //初始化请求
    search() {
      this.page.pageindex = 1;
      this.querylist();
    },
    //查询列表
    querylist() {
      let params = {
        page: this.page.pageindex,
        type: this.formdata.type,
        refund_type: this.formdata.refund_type,
        goods_name: this.formdata.goods_name
      };
      this.axios
        .post(api.order_after_sale, params)
        .then(response => {
          if (response.data.code == 0) {
            this.tableData = response.data.list;
            this.page.total = response.data.all_page;
          } else {
            this.page.total = 0;
          }
        })
        .catch(() => {});
    },
    // 切换类型查询
    changetype() {
      this.page.pageindex = 1;
      this.querylist();
    },
    // 分页
    pageIndexChange(pageindex) {
      this.page.pageindex = pageindex;
      this.querylist();
    },
    // 查询订单详情
    orderdetail(row, type) {
      this.currentid = row.id;
      this.currenttype = type;
      this.aftersalesdetaildialog = true;
    },
    // 审核
    audit(row) {
      this.currentid = row.id;
      this.aftersalesdetaildialog = true;
    },
    // 发货
    delivery(id) {
      this.currentid = id;
      this.deliverydialog = true;
    },    
    // 发货成功回调
    deliverysuccess() {
      this.querylist();
    }
  }
};
</script>

<style scoped>
.table_wrap .weui-cells{border: 1px dashed #ebebeb;}
.table_wrap .weui-cell{padding: 10px; border-top: 1px dashed #ebebeb;}
.table_wrap .weui-cell:first-child{border-top: 0;}
.table_wrap .weui-cell__hd img{display: block; width: 60px; height: 60px; object-fit: cover;}
.table_wrap .weui-cell__bd{padding: 0 10px;}
.table_wrap .weui-cell__ft{width: 80px; white-space: nowrap;}
</style>